import { UseQueryResult } from '@tanstack/react-query';
import { getGuides, Guide, GetGuidesRequestOptions } from '~/monolith-api';
import { useLocalization } from '~/framework';
import { useRegisteredQuery } from '~/queries';

const KEY = 'guides';

export function useGuides(options: GetGuidesRequestOptions): UseQueryResult<Guide[]> {
   const { _js } = useLocalization();
   return useRegisteredQuery(
      [KEY, options],
      async (): Promise<Guide[]> => {
         return await getGuides(options);
      },
      {
         keepPreviousData: true,
         errorMessages: getGuides.errorMessages({
            'guides.list.insufficient_permissions': _js(
               'You do not have permission to view private guides'
            ),
            default: _js('There was a problem retrieving guides; please try again.'),
         }),
      }
   );
}
